/**
 * @generated SignedSource<<45fe701c9f0837ed2901b88e144ef3d6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespSearchResultContainer_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SharedItemTile_viewer" | "usePartialItems_viewer" | "useSbSharedItemTracking_viewer">;
  readonly " $fragmentType": "SbRespSearchResultContainer_viewer";
};
export type SbRespSearchResultContainer_viewer$key = {
  readonly " $data"?: SbRespSearchResultContainer_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespSearchResultContainer_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespSearchResultContainer_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedItemTile_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useSbSharedItemTracking_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "usePartialItems_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "b267f938ee316828f7ef890749544867";

export default node;
